
/**
 * @export
 * @enum {string}
 */
export enum IntegrationPartner {
    SANDBOX = 'SANDBOX',
    FOUR_DEGREES = 'FOUR_DEGREES',
    SINGLETRACK = 'SINGLETRACK',
    MADE_MARKET = 'MADE_MARKET',
    DEAL_FABRIC = 'DEAL_FABRIC',
    NUCLA = 'NUCLA',
    DYNAMO = 'DYNAMO',
    BIPSYNC = 'BIPSYNC',
    MIDAXO = 'MIDAXO',
    SMART_MERGER = 'SMART_MERGER',
    DEAL_ROOM = 'DEAL_ROOM'
}